// video slideshow
(function() {
    $(document).ready(function() {
        let video_list = {
          0: {
              "video": "https://cdn.shopify.com/videos/c/o/v/99b10aaf56014d319b6f76f0dd31ef50.mp4",
              "source": "ruko",
              "poster": "https://cdn.shopify.com/s/files/1/0582/6963/0633/files/home-v1.webp?v=1690515769",
              "content": {
                  "title1": "Ruko Story",
                  "title2": "Clearer, Professional fun, Childhood dream",
                  "btn_url": "https://www.ruko.net/pages/about-us",
                  "btn_name": "VIEW MORE"
              }
          },

          1: {
              "video": "https://cdn.shopify.com/videos/c/o/v/0b6901015e644963bf96647a0d12a9ec.mp4",
              "source": "ruko",
              "poster": "https://cdn.shopify.com/s/files/1/0582/6963/0633/files/V11PRO-video-banner.webp?v=1733993352",
              "content": {
                  "title1": "Veeniix V11PRO",
                  "title2": "Next Level Drone for You",
                  "btn_url": "https://www.ruko.net/products/veeniix-v11pro",
                  "btn_name": "VIEW MORE"
              }
          },
          
          2: {
              "video": "https://cdn.shopify.com/videos/c/o/v/19b9adb1e72f407b9786a898acc4b32f.mp4",
              "source": "ruko",
              "poster": "",
              "content": {
                  "title1": "Veeniix V11",
                  "title2": "Capturing Your Happy Moments From Above",
                  "btn_url": "https://www.ruko.net/products/veeniix-v11",
                  "btn_name": "VIEW MORE"
              }
          },
          
          3: {
              "video": "https://cdn.shopify.com/videos/c/o/v/9fd6d7a565ea425a94552bf3807fc570.mp4",
              "source": "ruko",
              "poster": "https://cdn.shopify.com/s/files/1/0582/6963/0633/files/home-v2.webp?v=1690515769",
              "content": {
                  "title1": "Ruko F11GIM2",
                  "title2": "New Perspective Within Reach",
                  "btn_url": "https://www.ruko.net/products/ruko-f11gim2",
                  "btn_name": "VIEW MORE"
              }
          },
          4: {
              "video": "https://cdn.shopify.com/videos/c/o/v/35b897262ef74f1295de0fe4385b56b0.mp4",
              "source": "ruko",
              "poster": "https://cdn.shopify.com/s/files/1/0582/6963/0633/files/home-video-f7gb2.webp?v=1690516112",
              "content": {
                  "title1": "Bwine F7GB2",
                  "title2": "Shoot Clearer Night Scenes",
                  "btn_url": "https://www.ruko.net/products/bwine-f7gb2",
                  "btn_name": "VIEW MORE"
              }
          },
          5: {
              "video": "https://cdn.shopify.com/videos/c/o/v/17af9147c01044678aba978ab51475b3.mp4",
              "source": "ruko",
              "poster": "https://cdn.shopify.com/s/files/1/0582/6963/0633/files/home-v4.webp?v=1690515769",
              "content": {
                  "title1": "Ruko F11PRO",
                  "title2": "Fly Safe As Ever",
                  "btn_url": "https://www.ruko.net/products/ruko-f11pro",
                  "btn_name": "VIEW MORE"
                }
             },
          6: {
                "video": "https://cdn.shopify.com/videos/c/o/v/c3f1d09b93be4ba5959efacce63bf395.mp4",
                "source": "ruko",
                "poster": "https://cdn.shopify.com/s/files/1/0582/6963/0633/files/home-v5.webp?v=1690515769",
                "content": {
                    "title1": "Ruko F11MINI",
                    "title2": "Fly Anytime, Anywhere",
                    "btn_url": "https://www.ruko.net/products/ruko-f11mini",
                    "btn_name": "VIEW MORE"
                }
            },
          7: {
              "video": "https://cdn.shopify.com/videos/c/o/v/7424533f5fc747c3a37f5bc140d7515f.mp4",
              "source": "ruko",
              "poster": "https://cdn.shopify.com/s/files/1/0582/6963/0633/files/home-v6.webp?v=1690516032",
              "content": {
                  "title1": "Shot by Ruko",
                  "title2": "Make Childhood More Fun",
                  "btn_url": "https://www.ruko.net/collections/ruko-fun-toys",
                  "btn_name": "VIEW MORE"
              }
          },
        }

        let video_num = Object.keys(video_list).length;
        let video_width = is_mobile() ? ($(window).width()) : 1300;
        
        let duration = 800;
        if (is_mobile()) {
          duration = 600;
        }
        let autoplay = 1;
        let video_ratio = 0.5625;
        
        let translate = -(video_num + 1) * video_width;
        let youtube_params = "?autoplay=1&mute=1&loop=1&enablejsapi=1";
        let offset = 0;
        let video_playing = 0;
        let running = 0;
        
        // 初始化
        function video_initialize() {
            render_video();

            // 设置盒子长度和偏移
            $('.slider-videos-outer').css({
                'width': video_width + 'px',
                'height': (video_width * video_ratio) + 'px'
            });

            $('.slider-videos-list').css({
                "transform": "translateX(" + translate + "px)", 
                "width": ($('.slider-videos-list .slider-video-item').length * video_width) + 'px'
            }).show();

            // 指定中间视频
            $('.slider-videos-list .slider-video-item').eq(video_num+1).addClass('current-video-item');

            // 设置bullet
            for (let i=0; i<video_num; i++) {
                let html = "";
                if (i == 0) {
                  html = "<li num=" + i + " class='video-bullet-item active-video-bullet-item' >";
                } else {
                  html = "<li num=" + i + " class='video-bullet-item' >";
                }
                html += "<div class='video-bullet-item-inner'></div>";
                html += "</li>";
                $('.video-bullet-list').append(html);
            }
            $('.video-bullet-list .video-bullet-item').eq(0).addClass('active-video-bullet-item');

            // 非自动播放添加控件
            if (!autoplay) {
                $('.slider-videos-list .slider-video-item video').prop('controls',true);
            }

            let index1 = $('.current-video-item').index();
            set_video_content(index1, index1);
            play_video_when_scroll();
        }

        function render_video() {
            let list = [];
            let obj = {};
            obj[video_num - 1] = video_list[video_num - 1];
            list.push(obj);
            list.push(video_list);
            list.push(video_list);
            list.push({
                0: video_list[0],
                1: video_list[1],              
            });
          
            let html = '';
            html =  '<div class="video-slideshow-section">';
            html +=     '<div class="slider-videos-outer">';
            html +=         '<div class="slider-videos-list">';
            for (let i in list) {
              for (let j in list[i]) {
                let item = video_list[j];
                html +=         '<div class="slider-video-item" num="' + j + '" source="'+ item.source +'">';
                if (video_list[j]['source'] == 'ruko') {
                  html +=             '<video controls muted loop playsinline poster="'+item.poster+'" controlslist="nodownload nofullscreen noremoteplayback"><source src="'+item.video+'" type="video/mp4"></video>';
                } else {
                  html +=             '<iframe loading="lazy" class="youtube-video" vid="'+item.video+'" src="https://www.youtube.com/embed/'+item.video+'" frameborder="0" allowfullscreen></iframe>';
                }
                if (is_mobile()) {
                  let content = item['content'];
                  html +=         '<div class="video-content" >';
                  html +=             '<div class="video-content-inner">';
                  html +=                 '<h2 class="video-title1">'+content.title1+'</h2>';
                  html +=                 '<h2 class="video-title2">'+content.title2+'</h2>';
                  html +=                 '<a href="'+content.btn_url+'" class="video-btn"><span class="view-more-name">'+content.btn_name+'</span><img src="https://cdn.shopify.com/s/files/1/0582/6963/0633/files/right.png?v=1688368666" width="16" ></a>';
                  html +=             '</div>';
                  html +=         '</div>';
                }
                html +=         '</div>';
              }
            }
            html +=         '</div>';
            if (!is_mobile()) {
              html +=             render_video_content();
            }
            
            html +=         '<div class="video-prev"><img src="https://cdn.shopify.com/s/files/1/0582/6963/0633/files/left.png?v=1688368666" width="20"></div>';
            html +=         '<div class="video-next"><img src="https://cdn.shopify.com/s/files/1/0582/6963/0633/files/right.png?v=1688368666" width="20"></div>';
            html +=         '<ul class="video-bullet-list"></ul>';
            html +=     '</div>';
            html += '</div>';

            $('.hdt_nt_se_template--16990065787049__top_heading_689fXp').after(html);
          

            function render_video_content() {
                html = "";
                html +=         '<div class="video-content" >';
                html +=             '<div class="video-content-inner">';
                html +=                 '<h2 class="video-title1"></h2>';
                html +=                 '<h2 class="video-title2"></h2>';
                html +=                 '<a href="" class="video-btn"><span class="view-more-name"></span><img src="https://cdn.shopify.com/s/files/1/0582/6963/0633/files/right.png?v=1688368666" width="16" ></a>';
                html +=             '</div>';
                html +=         '</div>';
                return html;
            }
        }
              
        function play_video_when_scroll() {
            if (!autoplay) {
                return ;
            }
            let videoTop = $('.slider-videos-list').offset()?.top;
            let windowTop = $(window).scrollTop();

            if ((windowTop > videoTop - 500) && (windowTop < videoTop + 300)) {
                if (!video_playing) {
                    play_video();
                    video_playing = 1;
                }
            } else {
                if (video_playing) {
                    let current_video = $('.slider-videos-list .current-video-item').index();
                    reset_video(current_video);
                    video_playing = 0;
                }
            }
        }

        function run(direction = 'next') {
            if (running) {
                return ;
            }
            running = 1;

            let index1 = $('.current-video-item').index();
            let index2 = 0;
            if (direction == 'next') {
                index2 = index1 + 1;
            } else if (direction == 'prev') {
                index2 = index1 - 1;
            } else {
                let current_num = $('.current-video-item').attr('num');
                index2 = index1 + (direction - current_num);
            }

            set_bullet_active(direction);

          setTimeout(function() {
                running = 0;
                reset_position(index1, index2);

                reset_video(index1);
                setTimeout(function() {
                  play_video();
                }, 5);

            }, duration - -5);

            translate -= (index2 - index1) * video_width;
            $('.slider-videos-list').css({
                "transition": "transform " + duration + "ms",
                'transform': "translateX(" + translate + "px)",
            });
            
            set_video_content(index1, index2);
        };

        // 还原位置 
        function reset_position(index1, index2) {
            $('.current-video-item').removeClass('current-video-item');

            let gap = index2 - index1;
            offset = offset - -gap;

            if (Math.abs(offset) == video_num) {
                if (offset > 0) {
                    translate = translate - -video_width * video_num;    
                } else {
                    translate = translate - video_width * video_num;
                }

                index2 = index2 - offset;

                offset = 0;
                $('.slider-videos-list').css({
                    "transition": "none",
                    'transform': "translateX(" + translate + "px)",
                });
            }

            $('.slider-video-item').eq(index2).addClass('current-video-item'); 
        }

        function set_video_content(index1, index2) {
            if (is_mobile()) {
              return ;
            }
            $('.video-content').hide();
            if (index2 > index1) {
                $('.video-content .video-content-inner').css({'top': '-90%', 'opacity': '0'});
            } else {
                $('.video-content .video-content-inner').css({'top': '90%', 'opacity': '0'});
            }

            let video_num = $('.slider-video-item').eq(index2).attr('num');
            let content = video_list[video_num]?.['content'];

            let obj = $('.slider-videos-outer .video-content');
            obj.find('.video-title1').text(content?.title1);
            obj.find('.video-title2').text(content?.title2);
            obj.find('.video-btn').attr({'href': content?.btn_url, 'target': content?.btn_target});
            obj.find('.video-btn .view-more-name').text(content?.btn_name);
            if (!content?.btn_name) {
                obj.find('.video-btn').hide();
            } else {
                obj.find('.video-btn').show();
            }

            $('.video-content').show();
            $('.video-content .video-content-inner').animate({'top': '0', 'opacity': '1'}, 650);
        }

        // 停止并重置视频
        function reset_video(index1) {
            let last_box = $('.slider-video-item').eq(index1);
            let source = last_box.attr('source');
            if (source == 'ruko') {
                last_box.find('video').removeAttr('autoplay');
                let last_video = last_box.find('video')[0];

                let is_playing = last_video.currentTime > 0 && !last_video.paused && !last_video.ended && last_video.readyState > last_video.HAVE_CURRENT_DATA;
                if (is_playing) {
                    last_video.pause();
                    //last_video.currentTime = 0;
                }
            } else {
                let vid = last_box.find('iframe').attr('vid');
                last_box.find('iframe').attr('src', "https://www.youtube.com/embed/" + vid);
            }
        }

        // 播放视频
        function play_video() {
            if (!autoplay) {
                return ;
            }
            let current_box = $('.slider-videos-list .current-video-item')
            if (current_box.attr('source') == 'ruko') {
                //current_box.find('video')[0].currentTime = 0;
                current_box.find('video')[0].play();
            } else {
                let vid = current_box.find('iframe').attr('vid');
                let src = "https://www.youtube.com/embed/" + vid + youtube_params + "&enablejsapi=1&playlist=" + vid;
                current_box.find('iframe').attr('src', src);
            }
        }
        
        function set_bullet_active(type='next') {
            let current_index = $('.active-video-bullet-item').index();
            let next_index = 0;
            $('.active-video-bullet-item').removeClass('active-video-bullet-item');

            if (type == 'next') {
                next_index = (current_index + 1) >= video_num ? 0 : (current_index + 1);
            } else if (type == 'prev') {
                next_index = (current_index - 1) < 0 ? (video_num - 1) : current_index - 1;
            } else {
                next_index = type;
            }

            $('.video-bullet-item').eq(next_index).addClass('active-video-bullet-item');
        }

        function is_mobile() {
          if ($(window).width() > 960) {
            return false;
          }
          return true;
        }

        video_initialize();

        // 根据滚轮位置判断是否自动插件
        $(window).scroll(function() {
            play_video_when_scroll();
        })
        
        // 下一个视频
        $('.video-next').click(function() {
            run ('next');
        })

        // 上一个视频
        $('.video-prev').click(function() {
            run ('prev');
        })

        // 第n个视频
        $('.video-bullet-item').click(function() {
            if ($(this).hasClass('active-video-bullet-item')) {
                return ;
            }
            run ($(this).index());
        });

          
        /********************* 手指滑动轮播 **************************/
        function mobile_move() {
            let obj = $('.video-slideshow-section');
            let slideshowPoint = {
                "start_x": 0,
                "start_y": obj.offset().top,
                "end_x": obj.width(),
                "end_y": obj.offset().top + obj.height()
            }
            let touchPoint = {
                "start_x": 0,
                "start_y": 0,
                "end_x": 0,
                "end_y": 0
            }
            let startTime = 0;
            let endTime = 0;
            let beginTouch = false;
    
            // 手指开始滑动
            obj.bind('touchstart', function(e) {
                startTime = new Date().getTime();
                touchPoint.start_x = e.touches[0].pageX;
                touchPoint.start_y = e.touches[0].pageY;    
    
                beginTouch = true;
            });
            
            // 手指正在滑动
            obj.bind('touchmove', function(e) {
                if (beginTouch) {
                    touchPoint.end_x = e.touches[0].pageX;
                    touchPoint.end_y = e.touches[0].pageY;
                }
            });
    
            // 手指结束滑动
            obj.bind('touchend', function(e) {
                if (!beginTouch) {
                    return ;
                }
    
                endTime = new Date().getTime();
                let direction = slideshow_direction(slideshowPoint, touchPoint, startTime, endTime);
    
                // 还原设置
                beginTouch = false;
                touchPoint = {
                    "start_x": 0,
                    "start_y": 0,
                    "end_x": 0,
                    "end_y": 0
                }
                startTime = 0;
                endTime = 0;
    
                if (direction !== false) {
                    run (direction);
                }
            });
    
    
            function slideshow_direction(slideshowPoint, touchPoint, startTime, endTime) {
                // 范围判断
                if (touchPoint.start_x < slideshowPoint.start_x
                    || touchPoint.start_y < slideshowPoint.start_y
                    || touchPoint.end_x > slideshowPoint.end_x
                    || touchPoint.end_y > slideshowPoint.end_y
                    ) 
                {
                    return false;
                }
    
                // 时间判断
                let duration = endTime - startTime;
                if (duration <= 0) {
                    return false;
                }
    
                // 滑动距离
                let distanceX = touchPoint.end_x - touchPoint.start_x;
                let distanceY = touchPoint.end_y - touchPoint.start_y;
                
                // 位移角度判断 
                let x = Math.abs(distanceX); // 直角三角形短边 x 的长度
                let y = Math.abs(distanceY); // 直角三角形短边 y 的长度
                let angleInRadians = Math.atan(y/x); // 使用反正切函数计算夹角弧度
                let angleInDegrees = (angleInRadians * 180) / Math.PI; // 将弧度转换为角度
                if (angleInDegrees > 45) {
                    return false;
                }
    
                // 位置距离判断
                if (x < 35) {
                    return false;
                }
    
                // 位置方向判断
                if (distanceX > 0) {
                    return 'prev';
                }
    
                return 'next';
            }
        }
      
        if (is_mobile()) {
          mobile_move();
        }
    });
})();
